export default __webpack_public_path__ + "static/media/imagem_receeba.e50f820a.png";